export default {
    body: {
      cmpt: {
        type: 'CCabinetShipmentInfo'
      }
    }
  }
  